import { META, FRAMING } from "../../data/reportContent";
import { OrientationPanel } from "./OrientationPanel";

export const ReportHero = () => (
  <header className="report-hero" data-testid="report-hero">
    <span className="report-kicker">{META.edition} · {META.date}</span>
    <div className="report-hero-rule" />
    <h1 data-testid="report-title">{META.title}</h1>
    <p className="subtitle" data-testid="report-subtitle">{META.subtitle}</p>
    <p className="framing" data-testid="report-framing">{FRAMING}</p>
    <div className="report-hero-meta">
      <span>Full Report</span>
      <span>Prepared for trustees, staff, volunteers, community partners and funders</span>
    </div>
    <OrientationPanel />
  </header>
);
